import React, { useEffect, useState, memo } from "react";
import SliderCards from "./SliderCards";
import CategoriesBg from "../../../assets/images/CategoriesBg.svg";
import { useShopifyCategories } from "../../../staticQueries/useShopifyCategories";

const Categories = ({ bushbuckContentful }) => {
  const [bushBuckSlides, setBuckSlides] = useState(bushbuckContentful || []);
  const { Bushbuck } = useShopifyCategories();

  useEffect(() => {
    let bushbuck = [];
    bushbuckContentful?.forEach((contentfulCategory) =>
      Bushbuck?.forEach((shopifyCategory) => {
        if (shopifyCategory.shopifyId === contentfulCategory.shopifyId) {
          bushbuck.push({
            ...contentfulCategory,
            products: shopifyCategory.products.length || 0,
            vendor: shopifyCategory.products[0]?.vendor || "",
          });
        }
      })
    );
    setBuckSlides(bushbuck);
  }, []);

  return (
    <div className="relative block box-border" id="categories">
      <div
        className="relative pt-10 pb-[68px] md:pb-[90px] border-inherit bg-[#f2f2f2] z-[1] after:absolute after:contents-[''] 
        after:top-0 after:right-0 after:w-full after:h-full after:scale-x-[-1] after:bg-no-repeat after:bg-cover after:z-0"
        style={{
          backgroundImage: `url(${CategoriesBg})`,
        }}
      >
        <div className="w-full border-inherit">
          {/* <ToggleBrands activeTab={activeTab} setActiveTab={setActiveTab} /> */}

          <SliderCards data={bushBuckSlides} />
        </div>
      </div>
    </div>
  );
};

export default memo(Categories);
